import { render, staticRenderFns } from "./NewKpiFormula.vue?vue&type=template&id=5849bf6d&"
import script from "./NewKpiFormula.vue?vue&type=script&lang=js&"
export * from "./NewKpiFormula.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports